import {Link} from "react-router-dom";
import styled from "styled-components";

const CardsLink = styled(Link)`
    display: flex;
    flex-flow: column;
    width: 100%;
    // box-shadow: 0.5px 0.4px 0.5px 1.4px rgb(0, 195, 255);
    filter: drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017));
    border-radius: 10px;
    overflow: hidden;
    text-decoration: none;
`;

const CardsItemPicWrap = styled.figure`
    position: relative;
    width: 100%;
    height: 300px;
    overflow: hidden;

    &::after {
        content: attr(data-category);
        position: absolute;
        bottom: 0;
        margin-left: 10px;
        padding: 6px 8px;
        max-width: calc(100% - 60px);
        font-size: 12px;
        font-weight: 700;
        color: #fff;
        background-color: #1f98f4;
        box-sizing: border-box;
    }

    @media (min-width: 768px) {
        height: 700px;
    }
`;

const CardsItemImg = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.2s linear;
    &:hover {
        transform: scale(1.05);
    }
`;

const CardsItemInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px 8px 1px;
    background: rgb(31, 1, 16);
`;

const CardsItemParagraph = styled.p`
    font-size: 14px;
    padding: 8px;
    color: rgba(255, 255, 255, 0.8);
`;

function CardItem(props) {
    return (
        <CardsLink to={props.path}>
            <CardsItemPicWrap data-category={props.label}>
                <CardsItemImg src={props.src} alt={props.src} />
            </CardsItemPicWrap>
            <CardsItemInfo>
                <CardsItemParagraph>{props.paragraph}</CardsItemParagraph>
            </CardsItemInfo>
        </CardsLink>
    );
}

export default CardItem;
